export default __webpack_public_path__ + "static/media/ShieldIcon.9006c995.svg";